import React, {memo} from 'react';
import Container from '@/components/atoms/Container';
import Footer from '@/components/Ui-components/Common/footer';
import PopNavbar from '@/components/Ui-components/PopNavbar';
import OfficeAddress from '@/components/Ui-components/Address';
// Server-rendered: the footer is the site's largest internal-link surface, so it
// must exist in the raw HTML rather than appearing a tick after hydration.
import LatestFooter from '@/components/Ui-components/latest-footer';
import AppBar from '@/components/Ui-components/Common/app-bar';

const NewsLayout = (props: any) => {
    const {children} = props;

    return (
        <div>
            <div>
                <div className="app-bar-main">
                    <Container>
                        <AppBar />
                    </Container>
                </div>
            </div>
            <div className="layout-pop-nav-wrapper">
                <div>
                    <Container>
                        <PopNavbar />
                    </Container>
                </div>
            </div>

            <main id="main-content" role="main" className="mobile-top-margin" style={{marginTop: '20px'}}>
                {children}
            </main>

            <div className="address-main">
                <OfficeAddress className="contact_address_section" />
            </div>
            <LatestFooter />
            <Footer />
        </div>
    );
};

export default memo(NewsLayout);
